// Generated by scripts/sfut-legacy-manifest.mjs — do not edit by hand.
// SFUT Legacy metadata + 480px WebP card thumbnails in public/sfut-legacy/.
// Owners and new mints still come live from the explorer.

export type SfutLegacyManifestEntry = { name?: string; description?: string; image?: string; thumb?: string };

export const SFUT_LEGACY_THUMB_SIZE = 480;

export const SFUT_LEGACY_MANIFEST: Record<string, SfutLegacyManifestEntry> = {
  "0": {
    "name": "BCP",
    "description": "Horses have been a central part of my life for over 32 years. Since 2021, I have been competing at subtop level in the Netherlands, continuously developing both myself and my horses. Alongside compet…",
    "image": "ipfs://QmQ2uQ6jK5e4S6YnWWzh1j273HMUvXVFi9KH6ZTTNokVio",
    "thumb": "/sfut-legacy/0.webp"
  },
  "1": {
    "name": "PS. It's all about connection",
    "description": "Hi!\n\nMy name is Saskia Pilanen from the Netherlands. Also known from PS. it's all about connection! I have been working for myself as a horse riding instructor since 2018.\n\nOver the years, my work ha…",
    "image": "ipfs://QmcDTf5tVHFMYyd7ohfze3AXsmJ6upewGcoccNooDzTtiQ",
    "thumb": "/sfut-legacy/1.webp"
  },
  "2": {
    "name": "Meeting Stephen Hendry 1985 (Antwerp)",
    "description": "At the age of 16, Stephen Hendry was introduced to the Belgian mainland. Even then, he was already being hailed as the future world champion. This photograph was taken in Antwerp in 1985. Five years …",
    "image": "ipfs://QmPKXXWsszG2gGJqkUiZJvgpAsbQvYC6XPEXYWXmrH5pH4",
    "thumb": "/sfut-legacy/2.webp"
  },
  "3": {
    "name": "Meeting Stephen Hendry 1985 (Antwerp)",
    "description": "At the age of 16, Stephen Hendry was introduced to the Belgian mainland. Even then, he was already being hailed as the future world champion. This photograph was taken in Antwerp in 1985. Five years …",
    "image": "ipfs://QmPKXXWsszG2gGJqkUiZJvgpAsbQvYC6XPEXYWXmrH5pH4",
    "thumb": "/sfut-legacy/3.webp"
  },
  "4": {
    "name": "Tier 2, Right Hand, Gold Medal",
    "description": "First ever gold medal tournament win for the Super Heavyweight division.  Baytown, Texas, August 2026",
    "image": "ipfs://QmaXsKjaWyE8u41313sCk3uQgezMkkyuU3AdcLJ5kGGNh9",
    "thumb": "/sfut-legacy/4.webp"
  },
  "5": {
    "name": "MUGAMBA",
    "description": "They see the highlights i live the grind 4am runs. no excuses just results with no limitation good athlete? my work speaks louder pain is temporary but the title of athlete is forever",
    "image": "ipfs://QmXucFwWkbeNiQPgySmLor3RgcuiumGpaAk5UXTiakWxCG",
    "thumb": "/sfut-legacy/5.webp"
  },
  "6": {
    "name": "mugamba",
    "description": "The magical medal record uganda athletics tusker 2025 calendar year",
    "image": "ipfs://QmXWeyNmc8cQZNaDsLx8qivbV5hbFTNn2qku85HFSWCvqr",
    "thumb": "/sfut-legacy/6.webp"
  },
  "7": {
    "name": "mugamba",
    "description": "The magical medal record uganda athletics tusker 2025 calendar year",
    "image": "ipfs://QmXWeyNmc8cQZNaDsLx8qivbV5hbFTNn2qku85HFSWCvqr",
    "thumb": "/sfut-legacy/7.webp"
  },
  "8": {
    "name": "Mugamba",
    "description": "run with a vision focus on the ending line medal are waiting for you",
    "image": "ipfs://QmQXNE9yFK1Hnh3vwq1dEnN89hVNdGBW5Y7y9gDhTLuMNn",
    "thumb": "/sfut-legacy/8.webp"
  },
  "9": {
    "name": "SportsFuture Legacy",
    "description": "The official SportsFuture logo takes its rightful place as the inaugural piece in the newly opened SportsFuture.io Gallery.This landmark 1/1 NFT marks the official opening of the SportsFuture.io digi…",
    "image": "ipfs://QmUQX7wUVNx8Lu9m4T9R4EYrs32CdwiVotTaG7nyBqHKYL",
    "thumb": "/sfut-legacy/9.webp"
  },
  "10": {
    "name": "BCP",
    "description": "Horses have been a central part of my life for over 32 years. Since 2021, I have been competing at subtop level in the Netherlands, continuously developing both myself and my horses. Alongside compet…",
    "image": "ipfs://QmUmus1P8n55dnZvpCYPZ96jsqf32rWG49zr5UbRSed5gc",
    "thumb": "/sfut-legacy/10.webp"
  },
  "11": {
    "name": "250 Parkrun Achievement",
    "description": "250 Parkrun's — A milestone I will always be proud of.\n\nThis journey has been about so much more than completing 5K runs. It has brought early mornings, personal challenges, fresh air, encouragement,…",
    "image": "ipfs://QmciqVjnMngfpg41LmFQoqFXUfdhdhDXg9GXNBaf4mHvR7",
    "thumb": "/sfut-legacy/11.webp"
  },
  "12": {
    "name": "First sale ever with APTM coin",
    "description": "First product ever sold with Aptm Coin on 24/10/2025,\nPurchase was done at our store in Nigel South Africa",
    "image": "ipfs://QmPWXP1U8TmafdPDUSALkvhcs3MXPsNzSEPUmHw2CDfjJ8",
    "thumb": "/sfut-legacy/12.webp"
  },
  "13": {
    "name": "Built to Move Mountains",
    "description": "The first piece in the ENI Supplies Collection. Built to Move Mountains celebrates the machines, people and determination behind ENI — from bulk earthworks and plant hire to roads, dams and infrastru…",
    "image": "ipfs://QmVZMEv5rwxQfrRSL1GRAzBXUkdcy29maVkMyBky8PY3Ty",
    "thumb": "/sfut-legacy/13.webp"
  },
  "14": {
    "name": "My 250 Parkrun Milestone | Performing Markets",
    "description": "This NFT represents the connection between movement, mindset and the future of technology.\n\nCompleting 250 Parkrun's has taught me that progress comes from consistency: showing up, building habits, l…",
    "image": "ipfs://QmdurGzNCybiSQoyd5N3YwPzhdjGCS6yf1K9AEMuNcvVHL",
    "thumb": "/sfut-legacy/14.webp"
  },
  "15": {
    "name": "mugamba",
    "description": "Be here feel it sunshine are coming be the part in that story to tell days are now! ugandan athlete younger energetic coming champion.from scratch to win join the journey (it possible)",
    "image": "ipfs://Qmd9w3zQF1tdso8Tt29WoQedyiJXV1V1ahCEW2VARqZAjT",
    "thumb": "/sfut-legacy/15.webp"
  },
  "16": {
    "name": "APTM National hot sauce day",
    "description": "1st ever sale with APTM coin for consumable goods was this purchase of a bottle of Chilli sauce from Sol Foods on 24 October 2025",
    "image": "ipfs://QmbmMfThEUWNWr4s3wSYLUZ29sHA3x7dG2tJSthrCP76jJ",
    "thumb": "/sfut-legacy/16.webp"
  },
  "17": {
    "name": "Farming Tokenization",
    "description": "Tokenized farming and business for easy sponsorship to tokenized SPORT sponsorship",
    "image": "ipfs://QmNpDWNazq7Q1u9HdCNVwjwBRVyF8NGHsyH83vQAASQVi9",
    "thumb": "/sfut-legacy/17.webp"
  },
  "18": {
    "name": "MUGAMBA",
    "description": "Together We Run, Together We Rise................\n\n> They told me champions come from rich places. I come from low community\n> \n> I run while others sleep. I fall, I rise. When I am tired, I tell mys…",
    "image": "ipfs://QmSrkxyTfkVCaVgPdq2nrgkezYPs9LTCtKWzjvJwiU8BQ3",
    "thumb": "/sfut-legacy/18.webp"
  },
  "19": {
    "name": "Julian's first serious job!",
    "description": "Open worlds 2017 Barneveld, The Netherlands. Working as a front desk salesman",
    "image": "ipfs://Qmemw3KP4EoYTiHEvqiUJ2G9AERsfwdEkEs8h2Fnic7oGe",
    "thumb": "/sfut-legacy/19.webp"
  },
  "20": {
    "name": "Lisette's first award",
    "description": "Lisette's first award with her famous trainer/coach",
    "image": "ipfs://QmUBkg6XavVVQi7SsTprkmxhmRDs9snsXPWWz4DW4AEzZj",
    "thumb": "/sfut-legacy/20.webp"
  },
  "21": {
    "name": "Legacy 1935 SKI - Grandfather J. van Schaik",
    "description": "The world of SportsFuture.io started in the family legacy of van Schaik and the Grandfather J. van Schaik served his country for many years. \n\nTo honor his legacy and work here a historical permit of…",
    "image": "ipfs://QmPvtf7QjFg7p2zhY4wcoY2yCEF5rkKE4FkipF8wpuakum",
    "thumb": "/sfut-legacy/21.webp"
  },
  "22": {
    "name": "Legacy 1980 SKI - Father J.A. van Schaik",
    "description": "Awarded to J.A. van Schaik, Head of Administrative Processing at Spaarbeleg in Utrecht the Netherlands.\nIn lasting recognition of 25 years of loyal and dedicated service (1955–1980).\nA distinguished …",
    "image": "ipfs://QmdfTutyj4Fxut8EERiqGwKmdXHTrs1xwUPJiqQWPxYoZc",
    "thumb": "/sfut-legacy/22.webp"
  },
  "23": {
    "name": "Legacy 1983 SKI - Father J.A. van Schaik",
    "description": "Certificate of the National Board of N.K.S. Football.\nAwarded to J.A. van Schaik, born in Utrecht, in recognition of his outstanding services to the football movement in the Netherlands.\nThe Golden P…",
    "image": "ipfs://QmaHYSZCsV3LwZsJoFeFZ7ax5crKRPSi26NM6oAFe7vUhy",
    "thumb": "/sfut-legacy/23.webp"
  },
  "24": {
    "name": "Legacy 1986 SKI - Father J.A. van Schaik",
    "description": "Certificate of the KNVB Utrecht District.\nAwarded to J.A. van Schaik on 15 March 1986 in recognition of his services to football in the Utrecht region.\nThe Golden Pin of the Royal Netherlands Footbal…",
    "image": "ipfs://QmRs3RWHDMwkvPSUiQujt7hKxoBgEWAFYvPF2qwfwXDHrb",
    "thumb": "/sfut-legacy/24.webp"
  },
  "25": {
    "name": "Legacy 1993 SKI - Father J.A. van Schaik",
    "description": "Certificate of the Catholic sports club Pede Volucri Cogimus (P.V.C.).\nMr J.A. van Schaik is appointed Member of Merit in recognition of his outstanding services to the club. Utrecht, 1 January 1993.…",
    "image": "ipfs://QmTKq69soLHYBCd9SEDrntzV3gwaPeQb7tcZHK6rbpvMgP",
    "thumb": "/sfut-legacy/25.webp"
  },
  "26": {
    "name": "Legacy 1994 SKI - Father J.A. van Schaik",
    "description": "Certificate of the Catholic sports club Pede Volucri Cogimus (P.V.C.).\nMr J.A. van Schaik is appointed Honorary Member in recognition of his outstanding services to the club. Utrecht, 1 January 1994.…",
    "image": "ipfs://QmSZmnaLWvLzEkT6iVe2hPXYV2TG2S5KcH83nYzb3VB8tk",
    "thumb": "/sfut-legacy/26.webp"
  },
  "27": {
    "name": "Legacy 1995 SKI - Father J.A. van Schaik",
    "description": "Certificate of Honour awarded to J.A. van Schaik, Staff Member Personnel & Organisation at AEGON Nederland N.V...... In lasting recognition of 40 years of loyal and dedicated service (1955–1995).\nA d…",
    "image": "ipfs://QmbfLSJ12URFSt4kzFh4GNqsujPqzmTyBEPYntusjZn3eX",
    "thumb": "/sfut-legacy/27.webp"
  },
  "28": {
    "name": "Legacy 1996 SKI - Father J.A. van Schaik",
    "description": "Certificate of the Netherlands Catholic Sports Federation (NKS).\nJ.A. van Schaik, born in Utrecht, is appointed Member of the Honorary Council in the gold grade in recognition of his outstanding serv…",
    "image": "ipfs://Qme2mC9RzMSggvYmNkBgks8cpfHNtHaXpZjkt3KADo1so3",
    "thumb": "/sfut-legacy/28.webp"
  },
  "29": {
    "name": "Legacy 2001 SKI - Father J.A. van Schaik",
    "description": "The Mayor and Aldermen of Utrecht award J.A. van Schaik the Sports Medal of the City of Utrecht.\nIn lasting recognition of 46 years of dedicated voluntary service to sport in Utrecht, especially for …",
    "image": "ipfs://QmRvq5o2NF6XW6agVGVHmkVW6tfL7V2ZMcbdbhGJEKmfZd",
    "thumb": "/sfut-legacy/29.webp"
  },
  "30": {
    "name": "Legacy 2011 SKI - Father J.A. van Schaik",
    "description": "Vereniging Sport Utrecht appoints Jan van Schaik as Honorary Member. In lasting recognition of his outstanding services to sport in Utrecht. Utrecht, 28 June 2011..... Vereniging Sport Utrecht benoem…",
    "image": "ipfs://QmRNzuYUzxzfV1N4p4tUYoYXeptcHvcQrNLKpZUfM3dSKp",
    "thumb": "/sfut-legacy/30.webp"
  },
  "31": {
    "name": "Legacy 2013 SKI - Father J.A. van Schaik",
    "description": "Vereniging Sport Utrecht (VSU) appoints Jan van Schaik as Sports Ambassador. In lasting recognition of his outstanding services to sport in Utrecht.\nUtrecht, 30 May 2013..... Vereniging Sport Utrecht…",
    "image": "ipfs://QmbTiMC3Q7NmcKtR1bXMUzEbFRmcXTEAREBPyQp8NNKtUK",
    "thumb": "/sfut-legacy/31.webp"
  }
};
